<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app id="inspire">
    <v-content>
      <v-layout row justify-left>
        <v-flex md12>
          <span class="display-1">SurfAndScan Framework testen</span>
        </v-flex>
      </v-layout>

      <v-layout row justify-center>
        <v-flex md8>
          <v-flex md12>
            <span class="headline" justify-left>Hier können Sie die Befehle einfach ausführen und das Ergebnis prüfen</span>
          </v-flex>
          <v-expansion-panel>
            <v-expansion-panel-content key="1">
              <template v-slot:header>
                <div><span class="display-1">Konfiguration</span> Auslesen der ScanAndSurf Konfiguration</div>
              </template>
              <v-card>
                <v-card-text>
                  <v-btn @click="test1()">Jetzt ausführen</v-btn>
                  <v-flex md6>
                    Hiermit können Sie die Konfiguration von SurfAndScan auslesen
                  </v-flex>
                  <v-layout>
                  <v-flex md6>
                    <code>window.surfAndScan.getConfig(onSuccess, onFailed)
                    </code>

                  </v-flex>

                  <v-flex md6 style="background-color:lightgray">
                    Antwort:<br>
                    {{result1}}
                  </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content key="2">
              <template v-slot:header>
                <div><span class="display-1">Scanner</span> Auslesen der verfügbaren Scanner</div>
              </template>
              <v-card>
                <v-card-text>
                  <v-btn @click="test2()">Jetzt ausführen</v-btn>
                  <v-flex md6>
                    Hiermit können Sie die verfügbaren Scanner auslesen
                  </v-flex>
                  <v-layout>
                    <v-flex md6>
                      <code>window.surfAndScan.getDevices(onSuccess, onFailed)
                      </code>

                    </v-flex>

                    <v-flex md6 style="background-color:lightgray">
                      Antwort:<br>
                      {{result2}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content key="3">
              <template v-slot:header>
                <div><span class="display-1">Scanner starten</span> Scan ausführen</div>
              </template>
              <v-card>
                <v-card-text>
                  <span style="color:red;font-weight:bold" v-if="scanParameter.deviceAddress===null">!! Bitte zuerst Scanner einlesen !!</span>
                  <v-btn @click="test3()" v-if="scanParameter.deviceAddress!=null">Jetzt ausführen</v-btn>
                  <v-flex md6>
                    Hier wird ein Scan veranlasst auf dem Scanner mit der Id:<nobr>{{scanParameter.deviceAddress}}</nobr>
                    <br>
                  </v-flex>
                  <v-layout>
                    <v-flex md6>
                      <code>var scanParameter = {{scanParameter}};
  window.surfAndScan.scan(onSuccess, onFailed, parameter);
                      </code>

                    </v-flex>

                    <v-flex md6 style="background-color:lightgray">
                      Antwort:<br>
                      {{result3}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content key="4">
              <template v-slot:header>
                <div><span class="display-1">Scanstatus</span> Informationen über den aktuellen Scanvorgang</div>
              </template>
              <v-card>
                <v-card-text>
                  <span style="color:red;font-weight:bold" v-if="taskId===null">!! Bitte zuerst scan starten !!
                    <v-btn @click="demo()">Demo Task nutzen</v-btn>
                  </span>
                  <v-btn @click="test4()" v-if="taskId!=null">Jetzt ausführen</v-btn>
                  <v-flex md6>
                    Scanstatus abfragen
                  </v-flex>
                  <v-layout>
                    <v-flex md6>
                      <code>window.surfAndScan.getTaskStatus("{{taskId}}", onSuccess, onFailed)
                      </code>

                    </v-flex>

                    <v-flex md6 style="background-color:lightgray">
                      Antwort:<br>
                      {{result4}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content key="6">
              <template v-slot:header>
                <div><span class="display-1">Thumbails</span> Urls abfragen</div>
              </template>
              <v-card>
                <v-card-text>
                  <span style="color:red;font-weight:bold" v-if="taskId===null">!! Bitte zuerst scan starten !!</span>
                  <v-btn @click="test6()" v-if="taskId!=null">Jetzt ausführen</v-btn>
                  <v-flex md6>
                    Thumbnails abfragen
                  </v-flex>
                  <v-layout>
                    <v-flex md6>
                      <code>window.surfAndScan.getThumbnailUrl(file.id, this.taskId))
                      </code>

                    </v-flex>

                    <v-flex md6 style="background-color:lightgray">
                      Antwort:<br>
                      {{result6}}
                      {{thumbs}}
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <img :src="url" v-for="url in thumbs" :key="url" style="width: 80px; height:120px; padding: 2px;"/>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content key="5">
              <template v-slot:header>
                <div><span class="display-1">Scan herunterladen</span> Scandatei herunterladen</div>
              </template>
              <v-card>
                <v-card-text>
                  <span style="color:red;font-weight:bold" v-if="taskId===null">!! Bitte zuerst scan starten !!</span>
                  <v-btn @click="test5()" v-if="taskId!=null">Jetzt ausführen</v-btn>
                  <v-flex md6>
                    Task als PDF herunterladen
                  </v-flex>
                  <v-layout>
                    <v-flex md6>
                      <code>window.surfAndScan.downloadTaskAsPDF("{{taskId}}", "demo.pdf")
                      </code>

                    </v-flex>

                    <v-flex md6 style="background-color:lightgray">
                      Antwort:<br>
                      {{result5}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content key="7">
              <template v-slot:header>
                <div><span class="display-1">Upload to Host</span> Scantask hochladen</div>
              </template>
              <v-card>
                <v-card-text>
                  <span style="color:red;font-weight:bold" v-if="taskId===null">!! Bitte zuerst scan starten !!</span>
                  <v-btn @click="test7()" v-if="taskId!=null">Jetzt ausführen</v-btn>
                  <v-flex md6>
                    Task als File an host Senden
                    <v-text-field v-model="uploadTo" label="Host Ziel"></v-text-field>
                  </v-flex>
                  <v-layout>
                    <v-flex md6>
                      <code>
var headers = {
  'Authorization': 'BearerYourStuffHere',
  'AnyKey': 'AnyValueYouWant
}
var params = {
  taskId: {{taskId}},
  uploadTo: {{uploadTo}},
  groupFiles: 'true'
}
window.surfAndScan.uploadTaskToDestination:function (params, headers, fnSuccess, fnError)
                      </code>
                      Demo PHP Code uploadTest.php
                      <code>
header('Content-Type: application/json');

try {
    if ($_FILES['files']) {

        $data_string = json_encode(var_dump($_FILES['files']));
        echo $data_string;
    } else {
        print 'no files';
    }
}
catch (Exception $e)
{
    echo($e);
    exit(1);
}

                      </code>

                    </v-flex>

                    <v-flex md6 style="background-color:lightgray">
                      Antwort:<br>
                      {{result7}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
      <br><br>
    </v-content>
    <v-footer color="#3271b3" app>
      <v-spacer></v-spacer><span class="white--text">&copy; 2019 edologic GmbH</span><v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
import sas from 'surfandscan'
import Vue from 'vue'
export default {
  name: 'framework-test',
  data () {
    return {
      result1: null,
      result2: null,
      result3: null,
      result4: null,
      result5: null,
      result6: null,
      uploadTo: 'https://yourHost/uploadTest.php',
      result7: null,
      taskId: null,
      scanParameter: {
        duplex: false,
        feederUnit: 0,
        deviceAddress: null
      },
      thumbs: []
    }
  },
  mounted () {
    if (Vue.prototype.$config.isCloud) {
      sas.setHost('https://localhost.surfandscan.com:8000')
    } else {
      Vue.prototype.scanApi.updateUrl(sas)
    }
  },
  methods: {
    onSuccessTest1 (data) {
      this.result1 = data
    },
    onSuccessTest2 (data) {
      this.result2 = data
      if (data.length > 0) {
        this.scanParameter.deviceAddress = data[0].id
      }
    },
    onSuccessTest3 (data) {
      this.result3 = data
      this.taskId = data.id
    },
    onSuccessTest4 (data) {
      this.result4 = data
    },
    onFailed (data) {
      alert(JSON.stringify(data))
    },
    demo () {
      this.taskId = 'demo'
      this.test4()
    },
    test7 () {
      var params = {
        taskId: this.taskId,
        uploadTo: this.uploadTo,
        groupFiles: 'true'
      }
      var header = {
        'Authorization': 'BearerYourStuffHere'
      }
      sas.uploadTaskToDestination(params, header, this.onUploadDone, this.onFailed)
    },
    onUploadDone (data) {
      console.log('onUploadDone', data)
      this.result7 = data
    },
    test6 () {
      for (var index in this.result4.files) {
        var file = this.result4.files[index]
        this.thumbs.push(sas.getThumbnailUrl(file.id, this.taskId))
      }
    },
    test5 () {
      sas.downloadTaskAsPDF(this.taskId, 'demo.pdf')
    },
    test4 () {
      sas.getTaskStatus(this.taskId, this.onSuccessTest4, this.onFailed)
    },
    test3 () {
      sas.scan(this.onSuccessTest3, this.onFailed, this.scanParameter)
    },
    test2 () {
      sas.getDevices(this.onSuccessTest2, this.onFailed)
    },
    test1 () {
      sas.getConfig(this.onSuccessTest1, this.onFailed)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FrameworkTest.vue